<template>
  <div :style="`padding:${paddingH}`" v-if="!isHidden">
    <div class="buttonView" :class="{'setLoginPadding':isLoginPadding}" :style="`border:${borderStyle != null ? borderStyle : null}; background-color:${color != null ? color : 'white'}; padding:${paddingTop} `" @click="onPress">
      <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 0" width="24" height="24">
      <div class="buttonTitle" v-if="title != null" :style="`color: ${textColor != null ? textColor : 'white'}; margin-left: ${icon != null ? '4px' : '0'}; font-size: ${customFontSize}`">
        {{title}}
      </div>
      <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 1" width="24" height="24">
    </div>
  </div>
</template>

<script setup lang="ts">

import {onMounted, ref, defineExpose} from 'vue'
defineExpose({ onClear })
let call = defineEmits(["ButtonClick"])

let select = ref(false)

const props = defineProps({
  icon: {
    type: String,
  },
  title: {
    type: String,
  },
  color: {
    type: String,
  },
  textColor: {
    type: String,
  },
  borderStyle: {
    type: String,
  },
  selectIcon: {
    type: String,
  },
  initSelect: {
    type: Boolean,
  },
  onClick: {
    type: Function,
    default: null
  },
  isHidden: {
    type: Boolean,
    default: false
  },
  index: {
    type: Number,
  },
  iconType: {
    type: Number,
    default: 0
  },
  paddingTop: {
    type: String,
    default: "10px 30px"
  },
  paddingH: {
    type: String,
    default: "0 10px"
  },
  customFontSize: {
    type: String,
    default: "20px"
  },
  isLoginPadding: {
    type: Boolean,
    default: false
  }
})

function onPress() {
  if (props.selectIcon) {
    select.value = !select.value
  }
  call("ButtonClick",props.index)
  if (props.onClick) {
    props.onClick()
  }
}

function onClear() {
  console.log("onClear")
  select.value = false
}

onMounted(()=>{
  select.value = props.initSelect
})

</script>

<style scoped lang="scss">
.buttonView {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  &:hover{
    opacity: 0.6;
    cursor: pointer;
  }
}
.setLoginPadding{
  
}

.buttonTitle {
  font-size: 20px;
  white-space: nowrap;
}

</style>
